import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * 上传文件
 */
export const upload = (params: FormData): AxiosPromise => {
  return axios.post('/system/upload', params)
}
